import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import playerService from './playerService';
import { setAlertError } from '../alert/alertSlice';

export const uploadPlayers = createAsyncThunk('player/uploadPlayers', async (data, thunkAPI) => {
  return await playerService
    .uploadPlayers(data.fileName, data.eventId)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      const err = error.response?.data;
      const message = typeof err === 'string' ? err : err?.message;
      return thunkAPI.rejectWithValue(message || 'Failed to import players.');
    });
});

export const addPlayerToEvent = createAsyncThunk(
  'player/addPlayerToEvent',
  async (data, thunkAPI) => {
    return await playerService
      .addPlayerToEvent(data.eventId, data.player)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        const err = error.response.data;
        return thunkAPI.rejectWithValue(err.message);
      });
  }
);

export const updatePlayerFromEvent = createAsyncThunk(
  'player/updatePlayerFromEvent',
  async (data, thunkAPI) => {
    return await playerService
      .updatePlayerFromEvent(data.eventId, data.player)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        const err = error.response.data;
        return thunkAPI.rejectWithValue(err.message);
      });
  }
);

export const updatePlayerStatus = createAsyncThunk(
  'player/updatePlayerStatus',
  async (data, thunkAPI) => {
    return await playerService
      .updatePlayerStatus(data.eventId, data.playerId, data.status, data.reason)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        const err = error.response.data;
        thunkAPI.dispatch(setAlertError(err));
        return thunkAPI.rejectWithValue(err);
      });
  }
);

export const removePlayerFromEvent = createAsyncThunk(
  'player/removePlayerFromEvent',
  async (data, thunkAPI) => {
    return await playerService
      .removePlayerFromEvent(data.eventId, data.playerId)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        const err = error.response.data;
        thunkAPI.dispatch(setAlertError(err));
        return thunkAPI.rejectWithValue(err);
      });
  }
);

export const swapPlayerInEvent = createAsyncThunk(
  'player/swapPlayerInEvent',
  async (data, thunkAPI) => {
    return await playerService
      .swapPlayer(data.eventId, data.oldPlayerId, data.newPlayer)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        const err = error.response.data;
        return thunkAPI.rejectWithValue(err.message);
      });
  }
);

export const playerSlice = createSlice({
  name: 'players',
  initialState: {
    player: null,
    players: [],
    uploadingPlayers: false,
    addingPlayer: false,
    updatingPlayer: false,
    updatingPlayerStatus: false,
    removingPlayer: false,
    swappingPlayer: false
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(uploadPlayers.fulfilled, (state, action) => {
        state.uploadingPlayers = false;
        state.players = action.payload;
      })
      .addCase(uploadPlayers.rejected, (state, action) => {
        state.uploadingPlayers = false;
        state.players = [];
      })
      .addCase(uploadPlayers.pending, (state, action) => {
        state.uploadingPlayers = true;
        state.players = [];
      })
      .addCase(addPlayerToEvent.fulfilled, (state, action) => {
        state.addingPlayer = false;
        state.players = action.payload;
      })
      .addCase(addPlayerToEvent.rejected, (state, action) => {
        state.addingPlayer = false;
        state.players = [];
      })
      .addCase(addPlayerToEvent.pending, (state, action) => {
        state.addingPlayer = true;
        state.players = [];
      })
      .addCase(updatePlayerFromEvent.fulfilled, (state, action) => {
        state.updatingPlayer = false;
        state.players = action.payload;
      })
      .addCase(updatePlayerFromEvent.rejected, (state, action) => {
        state.updatingPlayer = false;
        state.players = [];
      })
      .addCase(updatePlayerFromEvent.pending, (state, action) => {
        state.updatingPlayer = true;
        state.players = [];
      })
      .addCase(updatePlayerStatus.fulfilled, (state, action) => {
        state.updatingPlayerStatus = false;
        state.players = action.payload?.players || action.payload;
      })
      .addCase(updatePlayerStatus.rejected, (state, action) => {
        state.updatingPlayerStatus = false;
      })
      .addCase(updatePlayerStatus.pending, (state, action) => {
        state.updatingPlayerStatus = true;
      })
      .addCase(removePlayerFromEvent.fulfilled, (state, action) => {
        state.removingPlayer = false;
        state.players = action.payload;
      })
      .addCase(removePlayerFromEvent.rejected, (state, action) => {
        state.removingPlayer = false;
        state.players = [];
      })
      .addCase(removePlayerFromEvent.pending, (state, action) => {
        state.removingPlayer = true;
        state.players = [];
      })
      .addCase(swapPlayerInEvent.fulfilled, (state, action) => {
        state.swappingPlayer = false;
      })
      .addCase(swapPlayerInEvent.rejected, (state, action) => {
        state.swappingPlayer = false;
      })
      .addCase(swapPlayerInEvent.pending, (state, action) => {
        state.swappingPlayer = true;
      });
  }
});

export default playerSlice.reducer;
